import * as React from "react";
import { Text, View, Image, TouchableOpacity, StyleSheet } from "react-native";

import { useNavigation, useRoute } from "@react-navigation/native";
// import { useDispatch } from "react-redux"; a part of cleaner code

import ForgotPassword from "../../components/auth/ForgotPassword";
import ForgotPasswordMobile from "../../components/auth/ForgotPasswordMobile";
import GlobalStyles from "../../components/GlobalStyles";
import { Ionicons } from "@expo/vector-icons";

export default function ForgotPasswordScreen() {
  const navigation = useNavigation();
  const route = useRoute();
  const formMode = route.params.formMode;
  const autofill = route.params.autofill;
  // const dispatch = useDispatch();

  return (
    <View style={GlobalStyles.containerMB}>
      <View style={GlobalStyles.bodyContainerT}>
        <View style={styles.HbuttonBar}>
          <TouchableOpacity
            style={styles.HbackButtonStyle}
            onPress={() => navigation.goBack()}
          >
            <Ionicons
              name="md-arrow-back"
              size={20}
              style={styles.HbackArrow}
            />
          </TouchableOpacity>
          <View>
            <Text style={styles.HTextStyle}>FORGOT PASSWORD</Text>
          </View>
          <View style={styles.HbackButtonStyle}></View>
        </View>
        <View style={styles.formBox}>
        {formMode === "p" ? (
          <ForgotPasswordMobile />
        ) : (
          <ForgotPassword autofill={autofill} />
        ) }
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  HbuttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 25,
  },

  HbuttonBarConf: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 30,
    marginLeft: 30,
    marginRight: 30,
  },

  HbackArrow: {
    color: "#fff",
  },

  HbackArrowBlack: {
    color: "#000",
  },

  HbackButtonStyle: {
    marginTop: 5,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },

  HTextStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  buttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
  },

  loginButton: {
    marginBottom: 40,
  },

  SubmitButtonStyle: {
    marginTop: 5,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
    backgroundColor: "#FFC72C",
    borderRadius: 20,
  },

  TextStyle: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  infoBox: {
    height: 300,
    backgroundColor: "#ffffff",
    borderRadius: 30,
    marginBottom: 20,
  },
});
